import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getCrossDomainRedirectTarget } from "../constants/siteDomains";

/**
 * Redireciona rotas acessadas no domínio errado (marketing ↔ app).
 * Complementa os 301 do .htaccess para garantir SPA + query strings.
 */
const DomainRedirect: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const target = getCrossDomainRedirectTarget(location.pathname, location.search);
    if (target) {
      window.location.replace(target);
    }
  }, [location.pathname, location.search]);

  return null;
};

export default DomainRedirect;
